import { MainBodyContentContainer } from "@sc/custom.styled";

export const QuizBodyContainer = MainBodyContentContainer.extend`
  overflow: auto;
`;
